import styled from "styled-components";

export const AuthorDetails = styled.div`
    display: flex;
    align-items: center;
    margin-right: 20px;
`;

export const AuthorDetailsIcon = styled.img`
    width: 18px;
    height: 18px;
    vertical-align: middle;
    margin-right: 5px;
`;

export const ContactDetailLink = styled.a`
    color: inherit;
    text-decoration: none;
    :hover {
        text-decoration: underline;
    }
`;